import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SharedLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/empresa/components/faq/FAQ.tsx");
